var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pkg-loading .pkg-loading-pic[data-v-4036adfb]{display:inline-block;width:35px;height:35px;margin-top:15px;margin-left:295px;background:url(" + escape(require("image/search-load.gif")) + ") 0/cover no-repeat}.pkg-loading .pkg-loading-title[data-v-4036adfb]{margin-top:5px;color:#929ca9;text-align:center}.pkg-dialog .pkg-footer[data-v-4036adfb]{float:right;padding:24px}.pkg-dialog .pkg-footer .pkg-btn[data-v-4036adfb]{padding:0 8px;margin-right:10px}.pkg-crumb[data-v-4036adfb]{box-sizing:border-box;padding-left:16px;background-color:#f6f7fa}", ""]);

// exports
